import Router from "next/router";
import type { NextPageContext } from "next";
import { HTTP_STATUSES } from "@/utils/http_constants";
import type { HttpStatus } from "@/utils/http_constants";

interface RedirectOptions {
  target: string;
  context?: Pick<NextPageContext, "res">;
  httpStatus?: HttpStatus;
  redirectionType?: "push" | "replace";
}

/**
 * Redirect function
 *
 * @param target Address
 * @param context Next.js context, need to perform redirect on server-side
 * @param httpStatus http status for redirect
 * @param redirectionType redirection type
 */
const redirect = ({
  target,
  context,
  httpStatus = HTTP_STATUSES.TEMPORARY_REDIRECT,
  redirectionType = "push",
}: RedirectOptions): void => {
  if (context?.res) {
    context.res.writeHead(httpStatus, {
      Location: target,
    });
    context.res.end();
  } else {
    redirectionType === "replace" ? Router.replace(target) : Router.push(target);
  }
};

export default redirect;
